// FAQ click
$(function () {
  $('.js-question').on('click', function () {
    if($(this).hasClass('is_open')) {
      $(this).removeClass('is_open');
      $(this).next().stop().slideUp(300);
    } else {
      $(this).addClass('is_open');
      $(this).next().stop().slideDown(300);
    }
    return false;
  });
});
